import { SELECCIONAR_CUENTACONTABLE, CARGAR_INDICADORCC } from './actionTypes';

export const seleccionar_CuentaContable = (ctaContable) => ({
	type: SELECCIONAR_CUENTACONTABLE,
	ctaContable
});

export const cargar_indicadorCCosto = (indicadorCCosto) => {
	return {
		type: CARGAR_INDICADORCC,
		indicadorCCosto
	}
}